import { Shell, type NavItem } from "../lib/Shell.js";

const ITEMS: NavItem[] = [
  { to: "/admin", label: "Clients & businesses", icon: "clients" },
  { to: "/admin/licenses", label: "Licences", icon: "licences" },
  { to: "/admin/rate-cards", label: "Rate cards", icon: "rates" },
  { to: "/admin/agent-config", label: "Receptionist config", icon: "agent" },
  { to: "/admin/industry-rules", label: "Industry rules", icon: "agent" },
  { to: "/admin/voice-instructions", label: "Voice instructions", icon: "agent" },
  { to: "/admin/communication", label: "Communication", icon: "numbers" },
  { to: "/admin/web-booking", label: "Online booking", icon: "numbers" },
  { to: "/admin/voip-usage", label: "VoIP usage sync", icon: "usage" },
  { to: "/admin/invoices", label: "Invoices", icon: "invoices" },
  { to: "/admin/call-debug", label: "Call debug", icon: "debug" },
  { to: "/admin/audit-log", label: "Audit log", icon: "audit" },
  { to: "/admin/developer-info", label: "Developer info", icon: "billing", separated: true },
  { to: "/admin/security", label: "Security", icon: "security" },
];

export function AdminShell() {
  return <Shell title="Admin" items={ITEMS} />;
}
